
























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';

@Component
export default class WidgetEnvironnementModals extends Vue {
  @Prop({ required: true }) readonly isMobileDevice: boolean;

  private _mapStore!: MapStore;
  private hideGreenSpaces = false;
  private hideAirQuality = false;

  created() {
    this._mapStore = getModule(MapStore, this.$store);
  }
}
